import Loading  from './Loading';
import { useFeatureToggle } from '../../utils/hooks/useFeatureToggle';
import React, { Suspense } from 'react';

export const FeatureToggle = ({ featureName, children, fallback }) => {
  const { isLoading, isFeatureEnabled } = useFeatureToggle(featureName);
  
  // Before isLoading is set to true it will be undefined
  if (isLoading === undefined || isLoading === true) {
    return <Loading />;
  }

  if (!isFeatureEnabled) {
    if (fallback) {
      return fallback;
    }

    return <></>;
  }

  return <Suspense fallback={<></>}>{children}</Suspense>;
};
